// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 6.4998V17.4998L1 17.5L1 6.5L5 6.4998Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 18.2099L15.0004 22.7095L15.0004 1.29004L7 5.7896V18.2099Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24 11H16V13H24V11Z"}}]};

const SoundDownFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sound-down-filled',
    ref,
    icon: element,
  },
));

SoundDownFilledIcon.displayName = 'SoundDownFilledIcon';

export default SoundDownFilledIcon;
